import { IconButton } from '@bnnvara/buttons';
import { Close } from '@bnnvara/icons/src/components/UserInterfaceIcons/Close';
import React from 'react';
import { withTheme } from 'styled-components';

import StyledCloseButton from './styled';

const CloseButton = withTheme(({ theme, onClick }) => (
  <StyledCloseButton>
    <IconButton onClick={onClick}>
      <Close color={theme.base.black} size={50} />
    </IconButton>
  </StyledCloseButton>
));

export default CloseButton;
